import React, {useImperativeHandle, useState} from 'react';
import {Modal, Row} from 'antd';
import ButtonComponent from '../../../atoms/Buttons';
import {PlusCircleOutlined, CloseCircleOutlined, DeleteOutlined} from '@ant-design/icons';
import {useNavigate} from 'react-router-dom';
import {defaultErrorMessage} from '../../../../utils/consts';

type GeneralModalProps = {
    onClose?: () => void;
};

type Icons = {
    [key: string]: React.ReactNode;
};

const icons: Icons = {
    add: <PlusCircleOutlined/>,
    error: <CloseCircleOutlined/>,
    delete: <DeleteOutlined/>,
    default: <PlusCircleOutlined/>
};

type IconsColor = {
    [key: string]: string;
};

const iconsColor: IconsColor = {
    add: 'green',
    error: 'red',
    default: 'white',
};

export interface GeneralModalRef {
    openModal: (message: string, icon: string, color: string, navigateTo?: string | null | undefined) => void;
}

const GeneralModal = React.forwardRef<GeneralModalRef, GeneralModalProps>((props, ref) => {
    const navigate = useNavigate();
    const [visible, setVisible] = useState(false);
    const [dialogMessage, setDialogMessage] = useState('');
    const [icon, setIcon] = useState('');
    const [color, setColor] = useState('');
    const [navigateToPath, setNavigate] = useState<string | undefined | null>(null);

    const handleCancel = async () => {
        setVisible(false)
        if (navigateToPath) navigate(navigateToPath);
        return Promise.resolve();
    };

    useImperativeHandle(ref, () => ({
        openModal(message: string, icon: string, color: string, navigateTo) {
            setDialogMessage(message);
            setColor(color);
            setVisible(true);
            setIcon(icon);
            if (navigateTo) setNavigate(navigateTo);
        }
    }));

    return <Modal title={<h2 style={{color: "#1677ff"}}>{'Promotify'}</h2>} open={visible} onCancel={handleCancel} centered
                  footer={[<ButtonComponent key={'close-button'} onClick={handleCancel} label={'Close'}
                                            buttonType={'default'} className={'cancel'}/>]}
                  style={{textAlign: 'center'}}>
        <Row justify={'center'}><p style={{fontSize: '22px'}}>{dialogMessage || defaultErrorMessage}</p></Row>
    </Modal>
});

GeneralModal.displayName = 'GeneralModal';

export default GeneralModal;